import { render, staticRenderFns } from "./examList.vue?vue&type=template&id=0b833864&scoped=true"
import script from "./examList.vue?vue&type=script&lang=js"
export * from "./examList.vue?vue&type=script&lang=js"
import style0 from "./examList.vue?vue&type=style&index=0&id=0b833864&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b833864",
  null
  
)

export default component.exports